import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.XeroRequestCard', {
    titleQuoteEmailToCustomer: 'Email to the Customer',
    attachmentsTitleQuoteEmailToCustomer: 'Attachments for the Customer',
    titleSalesInvoiceEmailToCustomer: 'Email to the Customer',
    attachmentsTitleSalesInvoiceEmailToCustomer: 'Attachments for the Customer',
});
